import { useNavigate } from "react-router-dom";

const ArticleSubHeader = (props: any) => {
  const navigate = useNavigate();
  const navigateToCreateParamHandler = () => {
    navigate("/article/create");
  };

  return (
    <>

      <div className="p-4">
        <div className="flex items-center justify-between w-full">
          <p className="text-xl font-bold text-[#43425D] w-1/5">
            ARTICLE
          </p>

          <div className="flex gap-4">
            {props.onDownloadClick && (
              <button 
                onClick={props.onDownloadClick} 
                disabled={props.isDownloading}
                className={`h-9 py-2 px-4 text-white font-semibold rounded shadow-md focus:outline-none focus:ring-2 focus:ring-opacity-75 flex gap-2 items-center ${props.isDownloading ? 'bg-blue-300 cursor-not-allowed' : 'bg-blue-500 hover:bg-blue-700 focus:ring-blue-400'}`}
              >
                <span>{props.isDownloading ? 'Downloading...' : 'Download Dump'}</span>
              </button>
            )}
            <button onClick={navigateToCreateParamHandler} className="h-9 py-2 px-4 bg-blue-500 text-white font-semibold rounded shadow-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-400 focus:ring-opacity-75">
              Create
            </button>
          </div>
        </div>
      </div>

    </>
  );
};
export default ArticleSubHeader;
